import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"about-our-product"}},[_c('base-section-heading',{attrs:{"color":"grey lighten-2","icon":"mdi-target","title":"Nos objectifs"}}),_c(VContainer,[_c(VRow,_vm._l((_vm.cards),function(card){return _c(VCol,{key:card.title,attrs:{"cols":"12","md":"4"}},[_c('base-info-card',_vm._b({},'base-info-card',card,false))],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }